import { getCookies } from "cookies-next";
import router from "next/router";
import React, { useEffect } from "react";
import store, { withServerStore } from "../store";

import {
  getAddressInfo,
  getBrandList,
  getCategoryList,
  getCmsList,
  getDynamicPageData,
  getDynamicPageList,
  getFeaturedList,
  getLocations,
  getMetaData,
  setAddressInfo,
  setBrandList,
  setCategoryList,
  setCmsList,
  setCurrentLocationId,
  setDynamicPageList,
  setLocations,
} from "../store/actions";

import {
  getRecentlyViewedListFromCookie,
  makeCityStateSlugUsingLocation,
  setCityStateSlugInCookie,
  setCurrentLocationIdInCookie,
} from "utils";

import Error500 from "components/Error500";
import Home from "components/home";
import Layout from "components/layout";

const Index = ({
  metaData,
  locations,
  brandList,
  categoryList,
  addressInfo,
  dynamicPageList,
  currentLocationId,
  features,
  data,
  isShowAddressInfo,
  selectedLocationName,
  currentPage,
  cmsList,
  cityStateSlug,
}) => {
  /******************** 
  @purpose : Set current location id in cookie
  @Parameter : {currentLocationId}
  @Author : INIC
  ******************/
  setCurrentLocationIdInCookie(currentLocationId);
  /******************** 
  @purpose : Set cityStateSlug in cookie
  @Parameter : {cityStateSlug}
  @Author : INIC
  ******************/
  setCityStateSlugInCookie(cityStateSlug);

  useEffect(() => {
    if (currentPage == "maintenance") {
      router.push("/maintenance");
    }

    /********************
  @purpose : Set location data,brandList,
  categoryList,addressInfo,dynamicPageList,cmsList,currentLocationId in redux
  @Parameter : {locations}
  @Author : INIC
  ******************/
    store.dispatch(setLocations(locations));
    store.dispatch(setBrandList(brandList));
    store.dispatch(setCategoryList(categoryList));
    store.dispatch(setAddressInfo(addressInfo));
    store.dispatch(setDynamicPageList(dynamicPageList));
    store.dispatch(setCmsList(cmsList));
    store.dispatch(setCurrentLocationId(currentLocationId));
  }, [currentLocationId, cityStateSlug]);

  return (
    <>
      {currentPage == "home" ? (
        <Layout
          page="home"
          metaData={metaData}
          locations={locations}
          brandList={brandList}
          categoryList={categoryList}
          addressInfo={addressInfo}
          dynamicPageList={dynamicPageList}
          currentLocationId={currentLocationId}
          isShowAddressInfo={isShowAddressInfo}
          selectedLocationName={selectedLocationName}
          cmsList={cmsList}
          currentPage={currentPage}
          homePageData={data?.page_details}
        >
          {/******************** 
        @purpose : Default page of react application
        @Author : INIC
        ********************/}
          <Home
            currentPage={currentPage}
            data={data}
            features={features}
            brandList={brandList}
            categoryList={categoryList}
            currentLocationId={currentLocationId}
          />
        </Layout>
      ) : (
        <>{currentPage == "500" ? <Error500 /> : <></>}</>
      )}
    </>
  );
};
export default Index;

/******************** 
  @purpose : server side rendering
  @Parameter : {}
  @Author : INIC
  ******************/

export const getServerSideProps = withServerStore(async ({ req, res, store }) => {
  let authorizationToken = "";
  if (getCookies({ req, res })?.token) {
    authorizationToken = getCookies({ req, res }).token;
  }
  const recentlyViewedVehicleArr = getRecentlyViewedListFromCookie(
    "",
    req,
    res
  ); // Adjust this function to work on the server if needed
  const slugIdsQuery = recentlyViewedVehicleArr
    .map((slugId, index) => `slugIds[${index}]=${slugId}`)
    .join("&");

  let id = "";
  let metaData = "";
  let locations = "";
  let brandList = "";
  let categoryList = "";
  let addressInfo = "";
  let dynamicPageList = "";
  let features = "";
  let data = "";
  let currentPage = "home";
  let isShowAddressInfo = "";
  let headerDark = "";
  let cmsList = "";
  let cityStateSlug = "";
  let list = "";

  // get locations list
  list = await store.dispatch(getLocations(true));

  if (list && list.statusCode != "503") {
    locations = list?.data;
    if (locations && locations.length > 0) {
      id = locations[0]["id"];
      cityStateSlug = makeCityStateSlugUsingLocation(locations[0]);

      const all = await Promise.all([
        store.dispatch(getMetaData(id, "home", "pageName")),
        store.dispatch(getAddressInfo(id)),
        store.dispatch(getFeaturedList()),
        store.dispatch(
          getDynamicPageData(id, "home", 0, authorizationToken, slugIdsQuery)
        ),
        store.dispatch(getBrandList(id)),
        store.dispatch(getCategoryList(id)),
        store.dispatch(getDynamicPageList(id)),
        store.dispatch(getCmsList()),
      ]);

      metaData = all[0];
      addressInfo = all[1];
      features = all[2];
      data = all[3];
      brandList = all[4];
      categoryList = all[5];
      dynamicPageList = all[6];
      cmsList = all[7];

      /*
        // get meta data of home page
        metaData = await store.dispatch(getMetaData(id, "home", "pageName"));

      // get address info using location id
      addressInfo = await store.dispatch(getAddressInfo(id));
     

      // get featured list  using location id
      features = await store.dispatch(getFeaturedList());

      // get home page data
      data = await store.dispatch(
        getDynamicPageData(id, "home", 0, authorizationToken)
      );

      // get brand list using location id
      brandList = await store.dispatch(getBrandList(id));

      // get category list using location id
      categoryList = await store.dispatch(getCategoryList(id));

      // get dynamic page using location id
      dynamicPageList = await store.dispatch(getDynamicPageList(id));

      // get cms list
      cmsList = await store.dispatch(getCmsList());
      */
    } else {
      currentPage = "500";
    }
  } else {
    currentPage = "maintenance";
  }

  return {
    props: {
      metaData: metaData,
      locations: locations ?? "",
      brandList: brandList,
      categoryList: categoryList,
      addressInfo: addressInfo,
      dynamicPageList: dynamicPageList,
      currentLocationId: id,
      features: features,
      data: data,
      isShowAddressInfo: true,
      selectedLocationName: "ca",
      currentPage: currentPage,
      cmsList: cmsList,
      cityStateSlug: cityStateSlug,
    },
  };
});
